import {useRef, useState} from "react"

import {Article} from "@proto/chatbot/v1alpha/chatbot"
import {CarouselScrollPointer} from "./icons"
import RelatedArticle, {IRelatedArticle} from "./RelatedArticle"

interface IProps {
    message?: string
    sponsoredArticles?: Article[]
}

const RelatedMessage = ({message, sponsoredArticles}: IProps) => {
    if (message === undefined && sponsoredArticles === undefined) return

    const scrollRef = useRef<HTMLDivElement>(null)
    const [isLeftActive, setLeftActive] = useState(false)
    const [isRightActive, setRightActive] = useState(true)

    const scroll = (scrollOffset: number) => {
        if (scrollRef.current) {
            if (scrollRef.current.scrollLeft + scrollOffset < 5) {
                setLeftActive(false)
            } else {
                setLeftActive(true)
            }
            if (scrollRef.current.scrollLeft + scrollOffset > 250) {
                setRightActive(false)
            } else {
                setRightActive(true)
            }
            scrollRef.current.scrollLeft += scrollOffset
        }
    }

    try {
        let articles
        if (message !== undefined && message.length > 0) {
            articles = JSON.parse(message)
        }

        if (sponsoredArticles && sponsoredArticles.length > 0) {
            articles = sponsoredArticles
        }

        if (articles.length == 0) {
            return
        }

        if (articles.length == 1) {
            return <RelatedArticle key="ra-first" article={articles[0]} single={true} />
        }

        const basePointerClass =
            "h-[40px] w-[40px] rounded-full absolute top-20 bg-white/90 border-[1px] border-input pl-[10px] pt-[10px] sm:hidden"

        return (
            <div className="relative">
                {isLeftActive ? (
                    <div className={basePointerClass + " rotate-180 cursor-pointer"} onClick={() => scroll(-256)}>
                        <CarouselScrollPointer />
                    </div>
                ) : (
                    <div className={basePointerClass + " rotate-180 "}>
                        <CarouselScrollPointer disabled={true} />
                    </div>
                )}
                <div
                    ref={scrollRef}
                    className="hide-scroll-bar m-[10px] flex overflow-x-scroll scroll-smooth pb-2
                    pl-[24px] pr-[24px]"
                >
                    <div className="flex flex-nowrap bg-white pl-[5px] pr-[5px]">
                        {articles.map((art: IRelatedArticle, i: number) => {
                            return <RelatedArticle key={i} article={art} />
                        })}
                    </div>
                </div>
                {isRightActive ? (
                    <div className={basePointerClass + " right-0 top-20 cursor-pointer"} onClick={() => scroll(256)}>
                        <CarouselScrollPointer />
                    </div>
                ) : (
                    <div className={basePointerClass + " right-0 top-20 "}>
                        <CarouselScrollPointer disabled={true} />
                    </div>
                )}
            </div>
        )
    } catch (e) {
        return
    }
}

export default RelatedMessage
